<template functional>
  <div class="quick-links columns">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'QuickLinks'
}
</script>

<style lang="scss" scoped>
@include mobile {
  .quick-links {
    margin: 0;
    width: 100%;

    &.columns:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
